import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { useToast } from "@/hooks/use-toast";
import { useEffect, useRef } from "react";

const RequireAdmin = ({ children, redirectTo = "/app/pdf" }: { children: React.ReactNode; redirectTo?: string }) => {
  const { loading, isAdmin } = useAuth();
  const { toast } = useToast();
  const warned = useRef(false);

  useEffect(() => {
    if (!loading && !isAdmin && !warned.current) {
      warned.current = true;
      toast({
        title: "Sección no disponible",
        description: "Esta funcionalidad aún no está habilitada para tu usuario.",
        variant: "destructive",
      });
    }
  }, [loading, isAdmin, toast]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <p className="text-muted-foreground">Cargando…</p>
      </div>
    );
  }

  if (!isAdmin) return <Navigate to={redirectTo} replace />;
  return <>{children}</>;
};

export default RequireAdmin;
